//-- Copyright (c) 2021 TMT Insights Group, LLC
import styled from '@emotion/styled';
import { IconButton, MenuItem, Tooltip, lighten } from '@mui/material';
import { MouseEventHandler, useState } from 'react';
import PolarisIcon from '../_common/PolarisIcon';
import DropdownSelect from '../_common/Form/DropdownSelect';

const ClientToggle = ({ configOptions }: { configOptions: any[] }) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [client, setClient] = useState<string>(localStorage.getItem('client') || 'ae');
  const keysOnly = configOptions.map((item) => item.key);

  const handleClick: MouseEventHandler<any> = (e) => {
    e.preventDefault();
    if (e.type === 'click') {
      // left click
      setIsMenuOpen(!isMenuOpen);
    } else if (e.type === 'contextmenu') {
      // right click
      const clientIndex = keysOnly.indexOf(client);
      const nextClient = keysOnly[(clientIndex + 1) % keysOnly.length];
      localStorage.setItem('client', nextClient);
      location.reload();
    }
  };

  const handleChange = (value: string) => {
    setClient(value);
    localStorage.setItem('client', value);
    setIsMenuOpen(false);
    location.reload();
  };

  return (
    <Wrapper>
      <DisappearingDiv visible={+isMenuOpen}>
        <DropdownSelect fullWidth={false} label="Client" name="client" value={client} size="small" onChange={handleChange}>
          {configOptions.map((item) => (
            <MenuItem key={item.key} value={item.key}>
              {item.label}
            </MenuItem>
          ))}
        </DropdownSelect>
      </DisappearingDiv>
      <Tooltip title="Right click to cycle through client configs" placement="bottom">
        <PaintbrushIconButton size="large" onClick={handleClick} selecting={+isMenuOpen} view={'disabled'}>
          <PolarisIcon icon="paintbrush" onContextMenu={handleClick} height={18} />
        </PaintbrushIconButton>
      </Tooltip>
    </Wrapper>
  );
};

export default ClientToggle;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: ${({ theme }) => theme.spacing(1)};
`;

const PaintbrushIconButton = styled(IconButton)<{ view: string; selecting: number }>`
  color: ${({ view, theme }) => {
    switch (view) {
      case 'disabled':
        return 'white';
      case 'active':
        return theme.palette.success.main;
      case 'inactive':
        return theme.palette.warning.main;
    }
  }};
  cursor: pointer;
  transform: ${({ selecting }) => (selecting ? 'rotate(-40deg)' : 'rotate(0deg)')};

  &:hover {
    color: ${({ view, theme }) => {
      switch (view) {
        case 'disabled':
          return 'white';
        case 'active':
          return lighten(theme.palette.success.main, 0.5);
        case 'inactive':
          return lighten(theme.palette.warning.main, 0.5);
      }
    }};
  }
`;

const DisappearingDiv = styled.div<{ visible: number }>`
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  padding-right: ${({ theme }) => theme.spacing(1.5)};

  .MuiFormControl-root {
    label {
      color: ${({ theme }) => theme.palette.primary.main};
    }

    svg {
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }
  .MuiInputBase-root {
    background: rgba(255, 255, 255, 0.09);
    color: white;
  }
`;
